import {
  GOOGLE_MAPS_SERVICE_ID,
  InjectScriptProps,
} from '@marketplace-web/shipping/google-maps-data'

import { loadScript } from '../../utils/script'

let googleApiLoadedCallbacks: Array<() => void> = []

const callGoogleApiCallbacks = () => {
  googleApiLoadedCallbacks.forEach(callback => callback())
}

const onGoogleCallback = (onGoogleApiLoaded: () => void) => {
  window.googleApiLoaded = callGoogleApiCallbacks

  if (!googleApiLoadedCallbacks.includes(onGoogleApiLoaded)) {
    googleApiLoadedCallbacks.push(onGoogleApiLoaded)
  }

  if (!window.google?.maps) return

  callGoogleApiCallbacks()
}

export const removeGoogleCallback = (callback: () => void) => {
  googleApiLoadedCallbacks = googleApiLoadedCallbacks.filter(
    loadedCallback => loadedCallback !== callback,
  )
}

export const loadGoogleApi = ({ apiKey, onGoogleApiLoaded }: InjectScriptProps) => {
  onGoogleCallback(onGoogleApiLoaded)

  if (document.getElementById(GOOGLE_MAPS_SERVICE_ID)) {
    return
  }

  const url = new URL('/maps/api/js', 'https://maps.googleapis.com')
  url.searchParams.set('key', apiKey)
  url.searchParams.set('libraries', ['places', 'geometry'].toString())
  url.searchParams.set('callback', 'googleApiLoaded')

  const src = url.toString()

  loadScript({ id: GOOGLE_MAPS_SERVICE_ID, src })
}
